import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { colors } from '../../styles/colors';
import { ReactComponent as LinkedInIcon } from './icons/linkedin.svg';
import { ReactComponent as TwitterIcon } from './icons/twitter.svg';
import { ReactComponent as GithubIcon } from './icons/github.svg';
import { ReactComponent as LogoIcon } from './icons/logo.svg';
import { modalStore } from '../../../entities/modal/model/modal.store';
import { axiosInstance } from 'shared/api/axios-instance';
const FooterContainer = styled.footer`
    background-color: #F6F9FC;
    padding: 40px 20px;
    width: 100%;
    @media (max-width: 768px) {
        padding: 30px 16px;
    }
`;
const FooterContent = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    @media (max-width: 1024px) {
    }
    @media (max-width: 768px) {
        flex-direction: column;
        gap: 44px;
    }
`;
const LogoSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
`;
const Logo = styled.div`
    svg {
        height: 60px;
    }
    @media (max-width: 768px) {
        svg {
            height: 45px;
        }
    }
`;
const ContactInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    @media (max-width: 768px) {
        margin-left: 32px;
    }
`;
const ContactItem = styled.div`
    font-size: 14px;
    color: ${colors.accentQuaternary6};
    line-height: 1.5;
`;
const ContactLabel = styled.span`
`;
const LinksColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
const ColumnTitle = styled.div`
    font-size: 16px;
    font-weight: 500;
    color: ${colors.accentQuaternary8};
    margin-bottom: 4px;
`;
const LinksList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
const FooterLink = styled.a`
    font-size: 14px;
    color: ${colors.accentQuaternary6};
    text-decoration: none;
    transition: color 0.2s;
    &:hover {
        color: ${colors.accentPrimary};
    }
`;
const SocialSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    @media (max-width: 768px) {
        align-items: center;
        text-align: center;
    }
`;
const SocialIcons = styled.div`
    display: flex;
    gap: 16px;
`;
const SocialIcon = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    transition: background-color 0.2s;
    svg {
        width: 20px;
        height: 20px;
    }
`;
const Divider = styled.div`
    height: 1px;
    background-color: ${colors.accentQuaternary3};
    margin: 24px 0;
`;
const BottomSection = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 768px) {
        flex-direction: column;
        gap: 16px;
        text-align: center;
    }
`;
const Copyright = styled.div`
    font-size: 14px;
    color: ${colors.accentQuaternary6};
`;
const LegalLinks = styled.div`
    display: flex;
    gap: 24px;
    cursor:pointer;
    @media (max-width: 768px) {
        flex-direction: column;
        gap: 12px;
    }
`;
const RightPart = styled.div`
    display: flex;
    flex: 1;
    justify-content: space-around;
    @media (max-width: 768px) {
        flex-wrap: wrap;
        gap: 64px;
    }
`
const LegalLink = styled.a`
    font-size: 14px;
    color: #648BEF;
    text-decoration: underline;
    &:hover {
        color: ${colors.accentPrimary};
    }
`;
interface FooterData{
  id:number;
  phone_number:string;
  email:string;
  updated_at:string;
}
export const Footer: React.FC = () => {
  const [footerData, setFooterData] = useState<FooterData | null>(null);
  const [isFooterUnavailable, setIsFooterUnavailable] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const fetchFooterData = async () => {
      try {
        const response = await axiosInstance.get<FooterData>('/api/footer/');
        if (!isMounted) {
          return;
        }
        setFooterData(response.data);
        setIsFooterUnavailable(false);
      } catch (error) {
        console.error('Failed to load footer data', error);
        if (!isMounted) {
          return;
        }
        setIsFooterUnavailable(true);
      }
    };

    void fetchFooterData();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <FooterContainer>
      <FooterContent>
        <LogoSection>
          <Logo>
            <LogoIcon/>
          </Logo>
          <ContactInfo>
            <ContactItem>
              <ContactLabel>Телефон:</ContactLabel>
              <br/>
             {footerData?.phone_number || (isFooterUnavailable ? 'Тимчасово недоступно' : '')}
            </ContactItem>
            <ContactItem>
              <ContactLabel>E-mail:</ContactLabel>
              <br/>
             {footerData?.email || (isFooterUnavailable ? 'Тимчасово недоступно' : '')}
            </ContactItem>
          </ContactInfo>
        </LogoSection>
        <RightPart>
          {/* <LinksColumn>
            <ColumnTitle>Текст</ColumnTitle>
            <LinksList>
              <FooterLink href="#">Посилання</FooterLink>
              <FooterLink href="#">Посилання</FooterLink>
            </LinksList>
          </LinksColumn>
          <LinksColumn>
            <ColumnTitle>Текст</ColumnTitle>
            <LinksList>
              <FooterLink href="#">Посилання</FooterLink>
              <FooterLink href="#">Посилання</FooterLink>
            </LinksList>
          </LinksColumn>
          <LinksColumn>
            <ColumnTitle>Текст</ColumnTitle>
            <LinksList>
              <FooterLink href="#">Посилання</FooterLink>
              <FooterLink href="#">Посилання</FooterLink>
              <FooterLink href="#">Посилання</FooterLink>
            </LinksList>
          </LinksColumn> */}
          {/* <SocialSection>
            <ColumnTitle>Соцмережі</ColumnTitle>
            <SocialIcons>
              <SocialIcon href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                <LinkedInIcon/>
              </SocialIcon>
              <SocialIcon href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <TwitterIcon/>
              </SocialIcon>
              <SocialIcon href="https://github.com" target="_blank" rel="noopener noreferrer">
                <GithubIcon/>
              </SocialIcon>
            </SocialIcons>
          </SocialSection> */}
        </RightPart>
      </FooterContent>
      <Divider/>
      <BottomSection>
        <Copyright>© ВККСУ Тестування IQ 2025</Copyright>
        <LegalLinks>
          <LegalLink onClick={() => modalStore.openModal('termsOfService')}>Відмова від відповідальності</LegalLink>
          <LegalLink onClick={() => modalStore.openModal('privacyPolicy')}>Політика конфіденційності</LegalLink>
          <LegalLink onClick={() => modalStore.openModal('offer')}>Договір оферти</LegalLink>
        </LegalLinks>
      </BottomSection>
    </FooterContainer>
  );
};
export default Footer;
